import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { MUSEFLOW_OFF_WHITE_3 } from 'Components/Colors';
import { CustomCircularProgress } from 'Components/StyledComponents';
import { authColumnWidth } from './authColumn';

// The pieces the sign-in and sign-up pages share, so the two stay matched.

const TERMS_URL = 'https://www.museflow.ai/terms';
const PRIVACY_URL = 'https://www.museflow.ai/privacy';

const dividerLineStyles = {
  height: '0px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: MUSEFLOW_OFF_WHITE_3,
  width: '100%',
};

const legalLinkStyles = { color: '#6F87F1' };

/** Full-screen spinner shown while a sign-in is in flight. */
export const AuthPendingOverlay: React.FC = () => (
  <Box
    data-testid="auth-pending-overlay"
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
    }}
  >
    <CustomCircularProgress />
  </Box>
);

/**
 * The one legal line, at the bottom of the card under the page's main button.
 * Small enough to sit on one line of the form column; it wraps rather than
 * going below 12px.
 */
export const TermsAndPrivacyLine: React.FC = () => (
  <Typography
    component="p"
    sx={{
      width: authColumnWidth,
      maxWidth: authColumnWidth,
      margin: '12px 0 0 0',
      color: '#767C8C',
      fontFamily: 'Lato',
      fontSize: '12px',
      lineHeight: '133%',
      textAlign: 'center',
    }}
  >
    By continuing, you agree to our{' '}
    <Link href={TERMS_URL} target="_blank" rel="noopener noreferrer" sx={legalLinkStyles}>
      Terms
    </Link>{' '}
    and{' '}
    <Link href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" sx={legalLinkStyles}>
      Privacy Policy
    </Link>
    .
  </Typography>
);

/** The "or" rule between the Google and Apple buttons and the form. */
export const OrDivider: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      width: authColumnWidth,
      maxWidth: authColumnWidth,
      alignItems: 'center',
      paddingTop: '12px',
      paddingBottom: '12px',
    }}
  >
    <Box sx={dividerLineStyles} />
    <Typography
      sx={{
        paddingLeft: '10px',
        paddingRight: '10px',
        color: MUSEFLOW_OFF_WHITE_3,
      }}
    >
      or
    </Typography>
    <Box sx={dividerLineStyles} />
  </Box>
);
